import { request } from "./http";


// 获取 CSRF Token
export const getCsrfToken = async () => {
  return request.get("/csrfToken");
};

export const loginApi = async (data) => {
  return request.put("/api/v1/entrance/login", data);
};

export const phoneLoginApi = async (data) => {
  return request.post("/api/v1/mobile/login", data);
};

export const ssoLogin = async (sid) => {
  return request.get("/api/v1/ssoLogin", {
    headers: {
      sessionId: sid,
    },
  });
};

export const logoutApi = async () => {
  return request.post("/api/v1/account/logout");
};

export const getProfile = async () => {

  return request.get("/api/v1/compute/user/userInfo");
};

// ========== 忘记密码相关 API ==========

/**
 * 发送验证码 (中文)
 * @param {Object} data - { mobile: string, type: "forgetPassword" | "register" }
 */
export const sendVerificationCode = async (data) => {
  return request.post("/api/v1/onlineActive/china/sendCode", data);
};

/**
 * 中文重置密码
 * @param {Object} data - { mobile: string, verificationCode: string, password: string (DES加密) }
 */
export const forgetPasswordCN = async (data) => {
  return request.post("/api/v1/onlineActive/china/forgetPassword", data);
};

/**
 * 发送重置邮件 (英文)
 * @param {Object} data - { email: string, source: "liCompute" }
 */
export const sendResetEmail = async (data) => {
  return request.post("/api/v1/onlineActive/us/resetPassword/sendEmail", data);
};

/**
 * 英文提交重置密码
 * @param {Object} data - { password: string (DES加密), shortKey: string }
 */
export const forgetPasswordUS = async (data) => {
  return request.post("/api/v1/onlineActive/us/resetPassword/submit", data);
};

// ========== 注册相关 API ==========

/**
 * 发送注册邮件（海外用户）
 * @param {Object} data - { email: string, source: "liCompute" }
 */
export const sendRegisterEmail = async (data) => {
  return request.post("/api/v1/onlineActive/us/sendRegisterEmail", data);
};

/**
 * 获取行业列表（海外用户）
 */
export const getIndustryList = async () => {
  return request.get("/api/v1/onlineActive/us/industry");
};

/**
 * 海外用户注册
 * @param {Object} data - { userName, email, company, password (DES加密), industry, shortKey? }
 */
export const registerUS = async (data) => {
  return request.post("/api/v1/onlineActive/us/register", data);
};
